<!-- eslint-disable max-lines -->
<template>
    <div class="asternDialog">
        <el-dialog
            class="form-dialog"
            title="到车登记"
            :visible.sync="visiable"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <el-form
                :label-position="labelPosition"
                :model="ruleForm"
                :rules="rules"
                label-width="100px"
                ref="ruleForm"
            >
                <el-row>
                    <el-col :span="14">
                        <div class="calendar">
                            <el-calendar v-model="arriveDate" ref="calendar"></el-calendar>
                            <span class="arrive-time">
                                <el-time-picker :clearable="false"
                                    v-model="arriveTime"
                                    placeholder="到车时间">
                                </el-time-picker>
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="车牌" prop="vehicleCard" class="label-form">
                            <el-input
                                clearable
                                :disabled="true"
                                v-model.trim="ruleForm.vehicleCard"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="司机" prop="driver" class="label-form">
                            <el-input
                                clearable
                                :disabled="true"
                                v-model.trim="ruleForm.driver"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="driverContactWay" class="label-form">
                            <el-input
                                clearable
                                :disabled="true"
                                v-model.trim="ruleForm.driverContactWay"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="到车时间" prop="actualArriveDate" class="label-form" clearable>
                            <el-input readonly clearable v-model="ruleForm.actualArriveDate"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="dialog-btn" @click="handleClose">取 消</el-button>
                <el-button class="dialog-cel" type="primary" @click="addOk">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 电子围栏校验提示和备注 -->
        <dispatch-handle-reason
            v-if="isShowHandleReasonDialog"
            ref="dispatchHandleReason"
            :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
            :componentsData="componentsData"
            :handleType="handleType"
            :dispatchNo="dispatchNo"
            :needTooltipData="needTooltipData"
            @handleSuccess="addOk"
            @closeFenceDialog="handleClose"
        ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import formatTime from '@/utils/common.js';
import DispatchHandleReason from '../../views/distributeManage/dispatchOrderLists/dispatchHandleReason/Index';
import { checkSiteAddressLclOperate } from '../../api/dispatchOrder';
export default {
    components: { DispatchHandleReason },
    props: {
        visiable: {
            type: Boolean,
            default: false
        },
        labelPosition: {
            type: String,
            default: 'right'
        },
        dataVisiableLists: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            ruleForm: {
                vehicleCard: '',
                actualArriveDate: formatTime.formatDateTime(new Date()),
                driver: '',
                driverContactWay: ''
            },
            arriveDate: new Date(),
            arriveTime: new Date(),
            rules: {
                actualArriveDate: [
                    {
                        required: true,
                        message: '请选择到车时间',
                        trigger: 'blur'
                    }
                ]
            },
            dispatchNo: '',
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'arrive', // 操作类型：到车
            componentsData: null,
            needTooltipData: []
        };
    },
    methods: {
        getData(data) {
            this.ruleForm.vehicleCard = data.vehicleCard;
            this.ruleForm.driver = data.driver;
            this.ruleForm.driverContactWay = data.driverContactWay;
            this.dispatchNo = data.dispatchNo;
            this.version = data.version; // 版本号
        },
        handleClose() {
            this.$emit('handleClose', '');
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence () {
            const params = {
                type: 'arrive',
                dispatchNo: this.dataVisiableLists.dispatchNo,
                siteAddressList: [this.dataVisiableLists.siteAddress]
            };
            return checkSiteAddressLclOperate(params).then(res => {
                if (Array.isArray(res.data) && res.data.length) {
                    this.needTooltipData = res.data;
                    return true;
                } else {
                    return false;
                }
            }).catch(() => {
                return false;
            });
        },
        /**
         * description 手动到车前 进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async addOk ({ isFenceRemarked = false }) {
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence();
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.componentsData = this.dataVisiableLists.siteAddress;
                    return;
                }
            }
            // 继续到车操作
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.$emit('addOk', { state: true, data: { ...this.ruleForm, index: this. dataVisiableLists.index} });
                    this.$emit('update:visiable', false);
                } else {
                    this.$emit('addOk', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        }
    },
    created() {
        this.getData(this.dataVisiableLists);
    },
    watch: {
        arriveDate(val) {
            const select = new Date(val).getTime() + 24 * 1000 * 3600 - 1;
            const now = new Date().getTime();
            if (now > select) return this.$message.warning('选择的日期不得小于当前时间');
            this.ruleForm.actualArriveDate = formatTime.formatDate(this.arriveDate) + ' ' + formatTime.formatDateTime(this.arriveTime).split(' ')[1];
        },
        arriveTime(val) {
            if (!val) {
                this.$message.warning('请选择时间！');
            } else {
                this.ruleForm.actualArriveDate = formatTime.formatDate(this.arriveDate) + ' ' + formatTime.formatDateTime(val).split(' ')[1];
            }
        }
    }
};
</script>

<style lang="less">
.asternDialog {
    .el-input--medium{
        font-size: 12px;
    }
     .el-date-editor.el-input {
        width: 174px !important;
    }
    .calendar {
        padding: 10px;
        border-right: 1px solid #ccc;
        text-align: right;
        .el-calendar-table td.is-selected {
            background-color: #e6f8f9;
        }
        .el-calendar-table:not(.is-range) td.next,
        .el-calendar-table:not(.is-range) td.prev {
            color: #c0c4cc;
        }
    }
    .arrive-time {
        margin-right: 20px;
    }
}
</style>
